import React, { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { RedirectProps } from 'react-router';

export const RedirectPreserveQuery: FC<RedirectProps> = (props) => {
  const { search } = useLocation();
  return <Redirect {...props} to={`${props.to}${search}`} />;
};
